import React from "react";
import * as styles from "./SubscribeToNewsletter.module.scss";
import { PartialSanityImageType } from "@silversea-ssc/ui-components-react";
import SubscribeInlineForm from "components/SubscribeToNewsletter/SubscribeInlineForm/SubscribeInlineForm";
import { FormDisclaimerFragment } from "types/graphql-types";
import EmotionalLauncher from "components/EmotionalLauncher/EmotionalLauncher";
import { INavLink } from "components/HeaderNavBar/type";
import { useRemotePromo } from "src/ssc-api/useRemotePromos";
import { isPresent } from "src/utils/checks";
import { isPromoValid } from "components/CustomPromo/promoValidation";
import { SubscribeFormContent } from "./types";

type Props = {
  backgroundImage: PartialSanityImageType | undefined;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
  formName: string;
  privacyPolicyUrl: INavLink;
  offerPageUrl: string | undefined;
  promoConfigurationCode?: string;
  subscribeFormContent: SubscribeFormContent;
};

const SubscribeToNewsletter: React.FC<Props> = ({
  backgroundImage,
  formDisclaimerContent,
  formName,
  privacyPolicyUrl,
  offerPageUrl,
  promoConfigurationCode,
  subscribeFormContent
}) => {
  const {
    customHeadingContent,
    customHeadingTitle,
    headingContent: content,
    headingTitle: title
  } = subscribeFormContent;
  const remotePromo = useRemotePromo(promoConfigurationCode);
  const isRemotePromoValid =
    isPresent(promoConfigurationCode) &&
    isPresent(remotePromo.data?.toDate) &&
    isPromoValid(promoConfigurationCode, remotePromo.data?.toDate);

  return (
    <EmotionalLauncher
      backgroundImage={backgroundImage}
      title={
        isRemotePromoValid && customHeadingTitle ? customHeadingTitle : title
      }
      content={
        isRemotePromoValid && customHeadingContent
          ? customHeadingContent
          : content
      }
      dataContentName={"subscribe_to_newsletter_section"}
      tokens={remotePromo.data?.tokenValues}
    >
      <div className={styles.form}>
        <SubscribeInlineForm
          formVariant="default"
          formButtonVariant="primary"
          formTitle={
            isRemotePromoValid && customHeadingTitle
              ? customHeadingTitle
              : title
          }
          formContent={
            isRemotePromoValid && customHeadingContent
              ? customHeadingContent
              : content
          }
          formName={formName}
          formDisclaimerContent={formDisclaimerContent}
          privacyPolicyUrl={privacyPolicyUrl}
          offerPageUrl={offerPageUrl}
          tokens={remotePromo.data?.tokenValues}
        />
      </div>
    </EmotionalLauncher>
  );
};

export default SubscribeToNewsletter;
